import { render, staticRenderFns } from "./MyAssTask.vue?vue&type=template&id=231a14f8&scoped=true"
import script from "./MyAssTask.vue?vue&type=script&lang=js"
export * from "./MyAssTask.vue?vue&type=script&lang=js"
import style0 from "./MyAssTask.vue?vue&type=style&index=0&id=231a14f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a14f8",
  null
  
)

export default component.exports